import React, { useState, useMemo } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import {
  Layout, Menu, Avatar, Card, Row, Col, Typography, Space,
  Descriptions, Dropdown, Button, List, Tag, Input, Badge
} from 'antd';
import {
  MenuFoldOutlined, MenuUnfoldOutlined,
  HomeOutlined, FileTextOutlined, TrophyOutlined,
  UserOutlined, LogoutOutlined, EditOutlined,
  PhoneOutlined, MailOutlined, EnvironmentOutlined, BellOutlined, SearchOutlined
} from '@ant-design/icons';
import colleges from '../bd.json';

const { Header, Sider, Content } = Layout;
const { Title, Text } = Typography;


function useCollege() {
  try {
    const raw = localStorage.getItem('auth');
    if (raw) return JSON.parse(raw);
  } catch { }
  return colleges[0];
}

export default function CollegeProfile() {
  const college  = useCollege();
  const navigate = useNavigate();
  const [collapsed, setCollapsed] = useState(false);
  const [search, setSearch]       = useState('');

  const initials = useMemo(
    () => (college.name || 'К').split(' ').map(w => w[0]).slice(0, 2).join('').toUpperCase(),
    [college.name]
  );


  const profileMenu = {
    items: [{
      key: 'logout',
      icon: <LogoutOutlined />,
      label: 'Выйти',
      onClick: () => { localStorage.clear(); navigate('/'); },
    }],
  };


  const menuItems = [
    { key: 'dashboard', icon: <HomeOutlined />,     label: <Link to="/dashboard">Кабинет</Link> },
    { key: 'surveys',   icon: <FileTextOutlined />, label: <Link to="/opros">Опросы</Link>    },
    { key: 'ratings',   icon: <TrophyOutlined />,   label: <Link to="/manager">Рейтинги (Проверка)</Link>  },
    { key: 'profile',   icon: <UserOutlined />,     label: 'Профиль'                            },
  ];

  return (
    <Layout style={{ minHeight: '100vh' }}>
   
      <Sider
        theme="light"
        width={220}
        collapsible
        collapsed={collapsed}
        onCollapse={setCollapsed}
        style={{ background: '#fff', borderRight: '1px solid #f0f0f0' }}
      >
        <div style={{
          height: 56,
          display: 'flex',
          alignItems: 'center',
          justifyContent: collapsed ? 'center' : 'flex-start',
          paddingInline: 24,
        }}>
          {collapsed ? (

   <svg width="25" height="51" viewBox="0 0 45 51" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M7.77487 16.6822L0 12.1542V39.3224L7.77487 43.3738V34.3177L22.8534 42.4206V33.3645L7.77487 25.2617V16.6822Z" fill="#113F71"/>
<path d="M15.0785 20.257L8.48168 16.2056L22.8534 8.1028L15.7853 4.0514L22.8534 0L33.9267 6.0771L45 12.1542L37.9319 16.2056L30.1571 12.1542L15.0785 20.257Z" fill="#113F71"/>
<path d="M37.4607 16.6822L30.1571 20.257V38.8458L23.3246 42.4206V51L45 39.3224V34.9135V30.5047L41.466 32.4112L37.9319 34.3177L37.4607 16.6822Z" fill="#113F71"/>
</svg>

  ) : (

  <svg width="143" height="51" viewBox="0 0 223 51" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M7.77487 16.6822L0 12.1542V39.3224L7.77487 43.3738V34.3177L22.8534 42.4206V33.3645L7.77487 25.2617V16.6822Z" fill="#113F71"/>
<path d="M15.0785 20.257L8.48168 16.2056L22.8534 8.1028L15.7853 4.0514L22.8534 0L33.9267 6.0771L45 12.1542L37.9319 16.2056L30.1571 12.1542L15.0785 20.257Z" fill="#113F71"/>
<path d="M37.4607 16.6822L30.1571 20.257V38.8458L23.3246 42.4206V51L45 39.3224V34.9135V30.5047L41.466 32.4112L37.9319 34.3177L37.4607 16.6822Z" fill="#113F71"/>
<path d="M77.4734 43H72.0291V12.9583H62V8H87.5025V12.9583H77.4734V43Z" fill="#113F71"/>
<path d="M104.695 8L90.3679 43H96.9585L106.701 18.5L116.157 43H121.888L108.134 8H104.695Z" fill="#113F71"/>
<path d="M152.548 43H130.484V8H135.929V38.3333H152.548V43Z" fill="#113F71"/>
<path d="M173.466 8L159.425 43H165.443L175.185 18.5L185.214 43H190.945L177.191 8H173.466Z" fill="#113F71"/>
<path d="M196.963 8V43H202.407V34.25H211.576C213.869 34.25 215.535 33.571 217.021 32.5011C228.89 23.9525 220.97 8 211.576 8H196.963Z" fill="#113F71"/>
<path d="M202 29V14H210.91C220.808 16.2233 217.035 29 210.91 29H202Z" fill="white"/>
</svg>

  )}
        </div>
        <Menu mode="inline" defaultSelectedKeys={['profile']} items={menuItems} />
      </Sider>


      <Layout>
    
        <Header
          style={{
            background: '#fff',
            paddingInline: 24,
            borderBottom: '1px solid #f0f0f0',
            display: 'flex',
            alignItems: 'center',
            gap: 16,
          }}
        >
          <Button
            type="text"
            icon={collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
            onClick={() => setCollapsed(!collapsed)}
          />

          <Title level={4} style={{ margin: 0, flexShrink: 0 }}>Профиль колледжа</Title>

          <Input
            prefix={<SearchOutlined />}
            placeholder="Поиск..."
            allowClear
            value={search}
            onChange={e => setSearch(e.target.value)}
            style={{ maxWidth: 240, marginLeft: 'auto' }}
          />

          <Space size="large">
            <Badge count={2}><BellOutlined style={{ fontSize: 18 }} /></Badge>
            <Dropdown menu={profileMenu} placement="bottomRight">
              <Avatar style={{ background: '#4B32C3', cursor: 'pointer' }}>{initials}</Avatar>
            </Dropdown>
          </Space>
        </Header>

       
        <Content style={{ background: '#F5F7FB', padding: '32px 24px' }}>
         
          <div style={{ margin: '0 auto', maxWidth: 1200 }}>
            <Row gutter={32}>
             
              <Col xs={24} lg={16}>
                <Card
                  title="Общие сведения о колледже"
                  bordered={false}
                  extra={<EditOutlined />}
                  style={{ borderRadius: 12 }}
                >
                  <Descriptions column={1} size="middle">
                    <Descriptions.Item label="Регион">{college.region}</Descriptions.Item>
                    <Descriptions.Item label="Наименование">{college.college_name}</Descriptions.Item>
                    <Descriptions.Item label="Территориальная принадлежность">
                      {college.area_type === 'городская местность' ? 'Город' : 'Сельская местность'}
                    </Descriptions.Item>
                    <Descriptions.Item label="Направление подготовки">
                      <Tag color="blue">IT</Tag>
                    </Descriptions.Item>
                    <Descriptions.Item label="Форма собственности">{college.common}</Descriptions.Item>
                    <Descriptions.Item label="Ведомственная принадлежность">МОН РК</Descriptions.Item>
                    <Descriptions.Item label="Орг-правовая форма">{college.type.toUpperCase()}</Descriptions.Item>
                  </Descriptions>
                </Card>
              </Col>

             
              <Col xs={24} lg={8} style={{ display: 'flex', flexDirection: 'column', gap: 24 }}>
                
                <Card
                  title="Контактные данные"
                  bordered={false}
                  extra={<EditOutlined />}
                  style={{ borderRadius: 12, flex: 1 }}
                >
                  <Space direction="vertical" size="large" style={{ width: '100%' }}>
                    <Space align="center">
                      <Avatar size={56} style={{ background: '#d6d6ff', color: '#4B32C3' }}>{initials}</Avatar>
                      <div>
                        <Text strong>{college.name.trim()}</Text><br/>
                        <Text type="secondary">Ответственный</Text>
                      </div>
                    </Space>
                    <Space><PhoneOutlined />{college.tel}</Space>
                    <Space><MailOutlined  />{college.college_email}</Space>
                    <Space><EnvironmentOutlined />{college.city}</Space>
                  </Space>
                </Card>

               
                <Card title="Полезные ссылки" bordered={false} style={{ borderRadius: 12 }}>
                  <List
                    size="small"
                    dataSource={[
                      'Руководство по заполнению профиля',
                      'График проведения оценки',
                      'Часто задаваемые вопросы',
                      'Связаться с поддержкой',
                    ]}
                    renderItem={t => <List.Item><Link to="#">{t}</Link></List.Item>}
                  />
                </Card>
              </Col>
            </Row>
          </div>
        </Content>
      </Layout>
    </Layout>
  );
}
